import { render, staticRenderFns } from "./LogoCompetitors.vue?vue&type=template&id=090c4948"
import script from "./LogoCompetitors.vue?vue&type=script&lang=js"
export * from "./LogoCompetitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports